<template>
    <div>
        <span style="font-size: 36px; line-height: 36px;" class="font-weight-bold text-danger">{{ currentDate.day }}</span><br>
        <span style="font-size: 30px; line-height: 30px;" class="font-weight-bold text-danger">{{ currentDate.month_min }}</span><br>
        <span style="font-size: 24px; line-height: 24px;" class="font-weight-bold text-danger">{{ currentDate.dayoftheweek }}</span><br>
        <span style="font-size: 12px; line-height: 24px;" class="font-weight-bold text-muted">{{ currentDate.holiday }}</span>
    </div>
</template>

<script>
let dayoftheweek_label = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
let month_min_label = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

import axios from "axios";

export default {
    name: 'componentToday',
    data: function() {
        return {
            currentDate: {
                day: 18,
                month_min: 'NOV',
                dayoftheweek: 'Sexta-feira',
                holiday: ''
            },
        }
    },
    created: function() {
        let now = new Date();
        this.currentDate.day = now.getDate();
        this.currentDate.month_min = month_min_label[now.getMonth()];
        this.currentDate.dayoftheweek = dayoftheweek_label[now.getDay()];

    }
}
</script>